import * as types from './mutation-types';
import Hub from '@/events/hub';
import store from '@/store';

let wsocket;
let tm = [];
let interval;

const connect = ({ dispatch, commit }) => {
  const wsLocation = process.env.SEARCH_LOCATION.replace('https://', '');
  let url = `wss://${wsLocation}/ws/`;
  const token = localStorage.getItem('access_token');
  url = `${url}?token=${token}`;
  wsocket = new WebSocket(url);
  const payload = {
    socketId: 1,
    channel: wsocket,
  };
  wsocket.onopen = () => {
    // Web Socket is connected, send data using send()
    // dispatch('sendData', { data: 'EyUhvItzXNxJrn6RhAED984lfG7u4J' });
    console.log('websocket open');
    commit(types.CONNECT, payload);
    // Sending ping every 30 sec
    interval = setInterval(() => {
      dispatch('ping');
    }, 30000);
  };

  wsocket.onmessage = (evt) => {
    const data = JSON.parse(evt.data);
    if (data.type === 'PONG') {
      console.log('inside onmsg before dispatching pong');
      dispatch('pong');
    } else
      dispatch('handleData', evt.data);
  };

  wsocket.onclose = () => {
    // websocket is closed.
    Hub.$emit('socket-disconnected');
    commit(types.DISCONNECT);
  };
};

const sendData = ({ commit }, payload) => {
  console.log('Sending data...!', payload);
  commit(types.SENDDATA, payload);
};

const handleData = ({ commit }, payload) => {
  commit(types.HANDLEDATA, payload);
};

const disconnect = ({ commit }) => {
  if (wsocket.readyState === WebSocket.OPEN)
    wsocket.close();
  commit(types.DISCONNECT);
};

const ping = () => {
  // it will send the message to server if there is no response then it will disconnect
  if (wsocket.readyState !== WebSocket.OPEN) {
    console.log('interval time', interval);
    clearInterval(interval);
    return;
  }
  console.log('inside ping wsocket state sending msg', wsocket.readyState);
  wsocket.send('{"type": "PING"}');
  tm.push(setTimeout(() => {
    console.log('dispatching disconnect');
    store.dispatch('socket/disconnect');
  }, 10000));
  console.log('tm on ping: ', tm);
};

const pong = () => {
  // Clear the timeout if message is received from server
  console.log('Inside pong. Clearing the timeout');
  tm.forEach(i => clearTimeout(i));
  tm = [];
  console.log('tm on pong: ', tm);
};

export default {
  connect,
  sendData,
  handleData,
  disconnect,
  ping,
  pong,
};



// WEBPACK FOOTER //
// ./src/store/modules/socket/actions.js